import React from 'react'
import { graphql } from 'gatsby'
import Layout from '../components/Layout'
import Seo from '../components/seo'
import marked from 'marked'
import { GatsbyImage } from 'gatsby-plugin-image'
import { Container, Row, Col } from 'react-bootstrap'
import { LazyLoadComponent } from 'react-lazy-load-image-component'
import ContactForm from '../components/forms/contact'

import 'react-lazy-load-image-component/src/effects/blur.css'
class IndexPage extends React.Component {
  render() {
    const siteTitle = this.props.data.site.siteMetadata.title
    const siteDescription = this.props.data.site.siteMetadata.description
    const news = this.props.data.allSanityPost.nodes
    return (
      <Layout location={this.props.location} title={siteTitle}>
        <Seo title={siteTitle} description={siteDescription} />
        <div id="hero">
          <Container>
            <Row>
              <Col lg={12} className="m-auto">
                <div className=" text-left py-5 mt-5">
                  <h4 className="hero-title">
                  Electronic Evidence Collection and eDiscovery Services When You Need Them
                  </h4>
                  <div className="mt-5">
                    <p className="hero-subtitle">
                    Avoid unnecessary review time, sanctions, unfavorable verdicts, and a blemished reputation in your evidence collection and eDiscovery workflow. Perin Discovery: Your source to collect, review and produce information triggered by litigation, internal investigations, FOIA's, and other information requests.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        {/* SECTION
          CALL TO ACTION
      */}

        <section id="ways">
          <Container>
            <Row>
              <Col xs={12} md={6}>
                <span className="section-p">
                  Need assistance from{' '}
                  <img
                    className="ways-logo"
                    alt="ways-logo"
                    src="/images/Perin_logo_white.svg"
                  ></img>{' '}
                  ?
                </span>
              </Col>
              <Col xs={12} md={6} className="pt-3">
                <a href="/contact-us" className="btn-primary">
                  CONTACT US
                </a>
              </Col>
            </Row>
          </Container>
        </section>

        {/* SECTION
          WHAT WE DO
      */}

        <section id="what-we-do">
          <Container className="container pb-5">
            <Row>
              <Col>
                <div className="text-left">
                  <h2 className="what-we-do-text section-subtitle">
                    What We Do
                  </h2>
                </div>
              </Col>
            </Row>
          </Container>
          <Container className="container pb-5">
            <Row>
              <Col>
                <div className="text-left">
                  <p className="what-we-do-subtext">
                  Perin Discovery provides teams with an efficient way to collect data and meet all the court and eDiscovery review tool requirements. Today's lawsuits demand modern collection techniques, software and expertise. Your adversaries know this so we give you insight and focus into your legal and response strategy. With the growth and diversity of data through emails, cell phones, apps, databases, and other online content, we believe this is more important than ever.
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
          <Container className="container pb-5">
            <Row className="mb-5">
              <Col lg="6" className="pr-lg-5 mb-5">
                <div className="card  mb-5">
                  <img
                    src="/images/digital-forensics.svg"
                    className="card-img-top"
                    alt="..."
                  />
                  <div className="card-body p-5">
                    <h4 className="card-title">Electronic Evidence Collection</h4>
                    <p className="card-text">
                      Perin ensures the data collected is verifiable and
                      forensically sound with an emphasis on creating an
                      evidentiary chain of custody. Our experience lends itself
                      to examining a large range of computing devices and
                      operating...
                    </p>
                    <div className="pt-5 pb-5">
                      <a
                        href="/our-services/?link=digitalforensic"
                        className="btn-primary-text btn-primary"
                      >
                        READ MORE
                      </a>
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg="6" className="pl-lg-5">
                <div className="card">
                  <img
                    src="/images/eDiscover.svg"
                    className="card-img-top"
                    alt="..."
                  />
                  <div className="card-body p-5">
                    <h4 className="card-title">eDiscovery</h4>
                    <p className="card-text">
                      After your ESI is collected by our team or your team,
                      Perin provides a range of services from early case
                      assessment and pre-review culling to final production and
                      data repository services to support you. Leveraging the
                      Relativity and CloundNine suites...
                    </p>
                    <div className="pt-5 pb-lg-5">
                      <a
                        href="/our-services/?link=ediscovery"
                        title="eDiscovery"
                        className="btn-primary-text btn-primary"
                      >
                        READ MORE
                      </a>
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg="6" className="pr-md-5 mb-5">
                <div className="card overflow-hidden">
                  <img
                    src="/images/cyber-investigation.png"
                    className="card-img-top"
                    alt="..."
                    style={{
                      width: '610px',
                      height: '195px',
                      objectFit: 'cover',
                    }}
                  />
                  <div className="card-body p-5">
                    <h4 className="card-title">Cyber Investigations</h4>
                    <p className="card-text">
                      Perin specializes in the most common types of cyber
                      breaches in the industry today: Business Email Compromise
                      and Ransomware investigations. Facing a breach can be a
                      business’s most difficult challenge. Get the support of
                      cybersecurity professionals with the framework of
                      forensics and eDiscovery, to guide your recovery.
                    </p>
                    <div className="pt-5 pb-lg-5">
                      <a
                        href="/our-services/?link=cyberinvestigation"
                        className="btn-primary-text btn-primary"
                      >
                        READ MORE
                      </a>
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg="6" className="pr-md-5 mb-5">
                <div className="card">
                  <img
                    src="/images/paper-discovery.svg"
                    className="card-img-top"
                    alt="..."
                  />
                  <div className="card-body p-5">
                    <h4 className="card-title">Paper Discovery</h4>
                    <p className="card-text">
                      At a time when documents and information are originating
                      overwhelmingly in electronic form, legacy media like paper
                      still makes up a population of evidentiary evidence. The
                      company’s roots dates to when paper was the dominant
                      source of...
                    </p>
                    <div className="pt-5 pb-lg-5">
                      <a
                        href="/our-services/?link=paperdiscovery"
                        className="btn-primary-text btn-primary"
                      >
                        READ MORE
                      </a>
                    </div>
                  </div>
                </div>
              </Col>
              {/* <Col lg="6" className="pl-md-5 mx-auto mt-5">
                <div className="card">
                  <img
                    src="/images/stuff-augmentation.svg"
                    className="card-img-top"
                    alt="..."
                  />
                  <div className="card-body p-5">
                    <h4 className="card-title">Staff Augmentation</h4>
                    <p className="card-text">
                      Finding quality and reliable personnel to fulfill case
                      projects can be a challenge and Perin’s blended technology
                      and people approach provides you a source for review and
                      production of datasets of any size. Whether you need
                      attorneys, paralegals,..
                    </p>
                    <div className="pt-5 pb-5">
                      <a
                        href="/our-services/?link=staffaugmentation"
                        className="btn-primary-text btn-primary"
                      >
                        READ MORE
                      </a>
                    </div>
                  </div>
                </div>
              </Col> */}
            </Row>
            <Row className="mt-5"></Row>
          </Container>
        </section>

        {/* SECTION
      WHO WE SERVE
      */}
        <section>
          <div className="container pb-5">
            <Row>
              <Col>
                <div className="text-left">
                  <h1 className="what-we-do-text section-subtitle">
                    Who We Serve
                  </h1>
                </div>
              </Col>
            </Row>
          </div>
          <Container>
            <Row>
              <Col lg={4}>
                <div className="card border-0 mb-5">
                  <div className="col">
                    <img
                      src="/images/law-firm.png"
                      className="card-img-top"
                      alt="..."
                    />
                    <div className="carousel-caption">
                      <b>Law Firms</b>
                    </div>
                  </div>
                  <div className="card-body">
                    <p className="paragraph-size-20 text-dark mb-5">
                      Need text messages from a cell phone collected? Need
                      employee emails collected for your case? Don’t have a
                      source for a remote collection? Don’t know the review tool
                      to use on your matter? Opposing counsel dump a dataset and
                      you don’t know where to start? Perin can help.
                    </p>
                    <div className="pb-3">
                      <a
                        className="paragraph-size-20 paragraph-text-light"
                        href="https://perindiscovery.sharefile.com/d-saa6efcdb88324ec48aecb7d79a328a5e"
                        target="_blank"
                      >
                        Download Law Firm Overview
                      </a>
                    </div>
                    <a
                      target="_blank"
                      href="/contact-us"
                      className="btn-block btn-primary text-center"
                    >
                      CONTACT US
                    </a>
                  </div>
                </div>
              </Col>
              <Col lg={4}>
                <div className="card border-0 mb-5">
                  <div className="col">
                    <img
                      src="/images/corporate.png"
                      className="card-img-top"
                      alt="..."
                    />
                    <div className="carousel-caption">
                      <b>Corporations</b>
                    </div>
                  </div>
                  <div className="card-body">
                    <p className="paragraph-size-20 text-dark mb-5">
                      Do you feel like you and your IT department are on
                      different planets? Feel a lack of insight or control with
                      your outside counsel? Concerned about your outside
                      counsel’s eDiscovery processes? Want the technology and
                      eDiscovery support without taking on the staff? Feel like
                      you need a forensics or eDiscovery advocate between you
                      and our outside counsel? Perin can help.
                    </p>
                    <div className="pb-3">
                      <a
                        className="paragraph-size-20 paragraph-text-light"
                        href="https://perininvestigations.sharefile.com/d-se8e3f2fbbff04a388c7fe3ae54d0b9df"
                        target="_blank"
                      >
                        Download Corporate Overview
                      </a>
                    </div>
                    <a
                      href="/contact-us"
                      className="btn-block btn-primary text-center"
                    >
                      CONTACT US
                    </a>
                  </div>
                </div>
              </Col>
              <Col lg={4}>
                <div className="card border-0 mb-5">
                  <div className="col">
                    <img
                      src="/images/government.png"
                      className="card-img-top"
                      alt="..."
                    />
                    <div className="carousel-caption">
                      <b>Government</b>
                    </div>
                  </div>
                  <div className="card-body">
                    <p className="paragraph-size-20 text-dark mb-5">
                      Have the budget but don’t have the time to wait for the
                      procurement process to play out? Have a mix of paper and
                      electronic documents and you don’t know where to start?
                      Hampered by legacy tools and manual labor methods to
                      search through data populations? Need help understanding
                      your technology and solution options when no other source
                      can be found. Perin can help.
                    </p>
                    <div className="pb-3">
                      <a
                        className="paragraph-size-20 paragraph-text-light"
                        href="https://perininvestigations.sharefile.com/d-sc7e3d418188c420f86814191f38c0f4c"
                        target="_blank"
                      >
                        Download Capability Statement
                      </a>
                    </div>
                    <a
                      href="/contact-us"
                      className="btn-block btn-primary text-center"
                    >
                      CONTACT US
                    </a>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/* SECTION
          WHY PERIN
      */}
        <section id="why-perin">
          <Container className="pb-5">
            <Row>
              <Col xs={12} className="mb-5">
                <h2 className="section-subtitle text-white">Why Perin?</h2>
              </Col>
              <Col xs={12}>
                <div className="paragraph-size-20 text-white">
                  <p>
                    <b>
                      Perin Discovery is an 8(a) SBA Certified, Native
                      American-owned, end-to-end eDiscovery and Cyber
                      Investigations firm based in Denver, Colorado.
                    </b>{' '}
                  </p>
                  <p>
                    We believe there is a better way to support teams and
                    entities responding to their litigation requests and cyber
                    investigations, and Perin's business was built to help them
                    respond to or build out modern and defensible operations.
                  </p>
                </div>
              </Col>
            </Row>

            <Row className="mt-5">
              <Col lg={5}>
                <img
                  src="/images/why-perin-img.png"
                  alt="why-perin"
                  className="mb-5 why-perin-img"
                />
              </Col>
              <Col lg={6} className="text-white paragraph-size-20">
                <p>
                  The growth of electronically stored information (ESI) through:
                </p>
                <ul className="order-checked pl-4">
                  <li className="list-checked">
                    <span className="text-white">Emails</span>
                  </li>
                  <li className="list-checked">
                    <span className="text-white">Cell Phones</span>
                  </li>
                  <li className="list-checked">
                    <span className="text-white">Other Connected Devices</span>
                  </li>
                  <li className="list-checked">
                    <span className="text-white">Online Content</span>
                  </li>
                  <li className="list-checked">
                    <span className="text-white">And Other Legacy Media</span>
                  </li>
                </ul>
                <p>
                  means parties need experts who can speak the language of a
                  forensics examiner, and who know how to put your team in the
                  best position for its review. Perin provides the bridges from
                  Collection to eDiscovery to Production, and legal to IT, and
                  our clients trust us as key stakeholders providing sound
                  counsel and support.
                </p>
              </Col>
            </Row>
          </Container>
        </section>

        {/* SECTION
          INSIGHTS
      */}
        <section>
          {news.slice(0, 1).map(blog => (
            <Row>
              {/*<img
                src="/images/insight-img.png"
                alt="insight"
                className="img-fluid"
              ></img>*/}
              <GatsbyImage
                image={
                  blog.mainImage ? blog.mainImage.asset.gatsbyImageData : ''
                }
                imgClassName="img-fluid"
                alt="Blog Img"
                placeholder="blurred"
                layout="constrained"
                style={{
                  height: '30rem',
                  width: '60rem',
                  borderRadius: '0 1rem 1rem 0',
                }}
              />
              <div className="col-md-6 pl-5 paragraph-size-20">
                <div className="pt-5">
                  <p className="insight-header">INSIGHTS</p>
                  <h2 className="section-subtitle text-dark my-5">
                    {blog.title}
                  </h2>
                  <p className="text-secondary">
                    {`${blog.excerpt.substr(0, 100)}...`}
                  </p>
                  <p>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: marked(`${blog.body.substr(0, 130)}...`),
                      }}
                    />
                  </p>
                  <div className="pt-5 pb-5">
                    <a
                      href={`/news/${blog.slug.current}`}
                      className="btn-primary-text btn-primary"
                    >
                      READ MORE
                    </a>
                  </div>
                </div>
              </div>
            </Row>
          ))}
        </section>

        {/* SECTION
          CONTACT US
      */}
        <section id="send-message">
          <Container>
            <Row>
              <Col lg={5} className="bg-white p-4 box-shadow rounded mb-5">
                <LazyLoadComponent>
                  <ContactForm />
                </LazyLoadComponent>
              </Col>

              <Col lg={7} className="pl-5">
                <div className="paragraph-size-20">
                  <div className="row custom-underline-contact">
                    <div className="col nopadding">
                      <h1 className="send-message-header">
                        Get In Touch With Us
                      </h1>
                      <div className="pt-3">
                        <span className="send-message-p">OUR LOCATIONS:</span>
                      </div>
                      <div className="row pb-2">
                        <div className="col-lg-6 pt-3">
                          <p className="">PERIN DISCOVERY</p>
                          <p>Colorado</p>
                          <a className="text-primary mt-0 mb-3" href="#popup1">
                            1888 N. Sherman Street
                            <br />
                            Suite 370
                            <br />
                            Denver, CO 80203
                            <div
                              id="popup1"
                              className="overlay"
                              style={{ zIndex: '10' }}
                            >
                              <div className="popup">
                                <div className="close-section">
                                  <a className="close" href="#">
                                    &times;
                                  </a>
                                </div>
                                <iframe
                                  scrolling="no"
                                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3067.72123039912!2d-104.98438519999999!3d39.74591240000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x876c7929cbb00001%3A0xeb2c5ed5a9b03b0!2s1888%20Sherman%20St%20Suite%20370%2C%20Denver%2C%20CO%2080203%2C%20USA!5e0!3m2!1sen!2sph!4v1690855121406!5m2!1sen!2sph"
                                  width={1000}
                                  height={600}
                                ></iframe>
                              </div>
                            </div>
                          </a>
                        </div>
                        <div className="col-lg-6 pt-3">
                          <p style={{ visibility: 'hidden' }}>SPACER</p>
                          <p>California</p>
                          <a className="text-primary mt-0 mb-3" href="#popup2">
                            1300 Eastman Ave.
                            <br />
                            Suite 102
                            <br />
                            Ventura, CA 93003
                            <div
                              id="popup2"
                              className="overlay"
                              style={{ zIndex: '10' }}
                            >
                              <div className="popup2">
                                <div className="close-section">
                                  <a className="close" href="#">
                                    &times;
                                  </a>
                                </div>

                                <iframe
                                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3297.517354828691!2d-119.2293872!3d34.2608573!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80e84d55d45ca3d5%3A0xb9eb0cdd5589bb8e!2s1300%20Eastman%20Ave%20%23102%2C%20Ventura%2C%20CA%2093003%2C%20USA!5e0!3m2!1sen!2sph!4v1690186005795!5m2!1sen!2sph"
                                  width={1000}
                                  height={600}
                                ></iframe>
                              </div>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 nopadding">
                      <p className="text-dark text-uppercase mb-1">Phone:</p>
                      <a
                        className="text-primary"
                        href="tel:833-234-6348"
                        title="Find It"
                      >
                        833-234-6348
                      </a>
                    </div>
                    <div className="col-md-6 nopadding">
                      <span>
                        <p className="text-dark text-uppercase mb-1">
                          TECHNICAL & CASE SUPPORT
                        </p>
                        <a
                          className="text-primary"
                          href="https://www.Support@PerinDiscovery.com"
                        >
                          Support@PerinDiscovery.com
                        </a>
                      </span>
                    </div>
                  </div>
                  <div className="row pb-3 custom-underline-contact">
                    <div className="col-md-6 nopadding">
                      <p className="mb-1">FAX:</p>
                      <a
                        className="text-primary"
                        href="tel:833-234-6348"
                        title="Find It"
                      >
                        833.234.6348
                      </a>
                    </div>
                    <div className="col-md-6 nopadding">
                      <span>
                        <p className="text-dark mb-1">EMAIL & WEBSITE</p>
                        <a
                          className="text-primary"
                          href="https://www.Info@PerinDiscovery.com"
                        >
                          Info@PerinDiscovery.com <br />
                        </a>
                        <a
                          className="text-primary"
                          href="https://www.PerinDiscovery.com"
                        >
                          https://www.PerinDiscovery.com
                        </a>
                      </span>
                    </div>
                  </div>
                  <div className="row">
                    <div className="pt-4">
                      <span className="send-message-p">STAY CONNECTED:</span>
                    </div>
                    <div className="pt-3 text-dark">
                      Please see our Facebook, LinkedIn, Twitter or Google
                      Business pages for current news and insights.
                    </div>
                    <ul className="list-inline pt-2">
                      <li className="list-inline-item">
                        <a
                          target="_blank"
                          rel="noreferrer"
                          href="https://www.facebook.com/end2endEDiscovery"
                        >
                          <img
                            src="/images/facebook-v3.svg"
                            alt="facebookIcon"
                            className="img-fluid mr-3"
                            width="32px"
                          />
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a
                          target="_blank"
                          rel="noreferrer"
                          href="https://www.linkedin.com/in/perin-discovery-6aaa98161/"
                        >
                          <img
                            src="/images/linkin-v3.svg"
                            alt="linkinin"
                            className="img-fluid mr-3"
                            width="32px"
                          />
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a
                          target="_blank"
                          rel="noreferrer"
                          href="https://twitter.com/PerinDiscovery"
                        >
                          <img
                            src="/images/twitter-v3.svg"
                            alt="youtubeIcon"
                            className="img-fluid mr-3"
                            width="32px"
                          />
                        </a>
                      </li>
                      {/* removed google icon */}
                      {/* <li className="list-inline-item">
                        <a
                          target="_blank"
                          rel="noreferrer"
                          href="https://g.page/r/CQ0MwGBiQXW8EBA?we"
                        >
                          <img
                            src="/images/business-v3.svg"
                            alt="shop"
                            className="img-fluid mr-3"
                            width="32px"
                          />
                        </a>
                      </li> */}
                    </ul>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </Layout>
    )
  }
}
export default IndexPage
export const IndexPageQuery = graphql`
  query IndexPageQuery {
    site {
      siteMetadata {
        title
        author
        description
      }
    }
    allSanityPost(sort: { fields: publishedAt, order: DESC }) {
      nodes {
        id
        title
        slug {
          current
        }
        publishedAt
        excerpt
        body
        mainImage {
          asset {
            gatsbyImageData(
              layout: CONSTRAINED
              width: 1920
              placeholder: BLURRED
              sizes: "(max-width: 1920px) calc(100vw - 40px), 1920px"
            )
          }
        }
      }
    }
  }
`
